module.exports = __webpack_public_path__ + "static/media/Bicocca - white_DK Gold.99455e46.jpg";